import AdminLayout from "components/admin/layout"
import AppHistory from "shared/history"
import Button from "components/inputs/button"
import {digg} from "diggerize"
import {FlashNotifications as FlashMessage} from "flash-notifications"
import I18n from "shared/i18n"
import inflection from "inflection"
import Input from "components/inputs/input"
import Locales from "shared/locales"
import PageComponent from "components/page-component"
import PropTypes from "prop-types"
import React from "react"
import Routes from "shared/routes"
import {ScoreFactor} from "models"
import translatedAttributes from "@kaspernj/api-maker/build/translated-attributes.js"
import {v4 as uuidv4} from "uuid"
import withModel from "components/wooftech-with-model"
class RoutesAdminScoreFactorsEdit extends PageComponent {
  static propTypes = {
    scoreFactor: PropTypes.instanceOf(ScoreFactor),
    scoreFactorId: PropTypes.string
  }

  render() {
    const {onSubmit} = this.t
    const {scoreFactor} = this.p

    return (
      <AdminLayout active="score-factors" className="routes--admin--score-factors--edit" headerTitle={this.headerTitle()}>
        {scoreFactor &&
          <form onSubmit={onSubmit}>
            {Locales.availableLocales().map((locale) =>
              <React.Fragment key={locale}>
                <Input
                  attribute={`name${inflection.camelize(locale)}`}
                  label={`${ScoreFactor.humanAttributeName("name")} (${Locales.labelForLocale(locale)})`}
                  model={scoreFactor}
                />
              </React.Fragment>
            )}
            <Input attribute="icon" model={scoreFactor} />
            <Input attribute="color" model={scoreFactor} />
            <Input attribute="secondaryColor" model={scoreFactor} />
            <Button primary save />
          </form>
        }
      </AdminLayout>
    )
  }

  headerTitle() {
    const {scoreFactor} = this.p

    if (scoreFactor?.isNewRecord()) {
      return I18n.t("js.routes.admin.score_factors.edit.add_new_score_factor")
    } else if (scoreFactor?.isPersisted()) {
      return I18n.t("js.routes.admin.score_factors.edit.edit_score_factor", {name: scoreFactor.name()})
    }
  }

  onSubmit = async (e) => {
    e.preventDefault()

    const form = digg(e, "target")
    const formData = new FormData(form)
    const {scoreFactor} = this.p

    if (scoreFactor.isNewRecord()) formData.append("score_factor[id]", scoreFactor.id())

    try {
      await scoreFactor.saveRaw(formData, {form})
      FlashMessage.success(I18n.t("js.routes.admin.score_factors.edit.the_score_factor_was_saved"))
      AppHistory.push(Routes.adminScoreFactorPath(scoreFactor.id()))
    } catch (error) {
      FlashMessage.errorResponse(error)
    }
  }
}

const selectedScoreFactorAttributes = ["color", "icon", "id", "name", "secondaryColor"]
  .concat(translatedAttributes(["name"], Locales.availableLocales()))

export default withModel(
  RoutesAdminScoreFactorsEdit,
  ScoreFactor,
  {
    newIfNoId: {
      defaults: () => ({id: uuidv4()})
    },
    select: {
      ScoreFactor: selectedScoreFactorAttributes
    }
  }
)
